module.exports = __webpack_public_path__ + "img/ararat-age-confirm-bg-mobile.da836d28.jpg";